export class AuthURL {
  public static EndPoints = {
    auth: {
      user: {
        conformMail: '/org/auth/forgot-password',
        changePassword: '/org/auth/forgot-password-verification',
        login: '/org/auth/login',
        refreshToken: '/org/auth/refresh-token',
        logout: '/org/auth/logout',
        userInfo: '/org/user/page/list',
        userRole: '/org/user/{id}',
        routeToDynamicPage:
          '/platform/page-designer/page/organization/{orgid}?returnUserPage=true&excludeNoActiveVersionPages=true',
        authMe: '/org/auth/me',
        resetPassword: '/org/user/reset-password',
        orgList: '/org/management-group/organization/tree',
        notification: '/worker/notification',
        workerAvailability: '/worker/updateAvailablity',
        getWorkerAvailability: '/worker/getByCurrentUser',
        generateLoginUrl: '/org/auth/get-login-url',
        getTokenValidationUrl: '/org/auth/token-validation',
        setCookie: '/org/auth/set-cookie',
      },
      permission: {
        permissionRoleById: '/access-control/permission/role/{id}',
        pagePermission: '/access-control/permission/page',
        pageLookupPermission: '/access-control/permission/page/lookup'
      },
      microstrategy: {
        login: '/platform/microstrategy/login',
        getLibrary: '/platform/microstrategy/library'
      }
    }
  };
}
